import { InterfaceObject } from './interface-object.types';

// Core Object Service Actions
export class SetObjectState {
  static readonly type = '[Interface] Set Interface Object State';
  constructor(public entities: any) {}
}

export class ResetState {
  static readonly type = '[Interface] Reset State';
  constructor() {}
}

export class PrepareRequest {
  static readonly type = '[Interface] Prepare Request';
  constructor(public tranOptions: any) {}
}

export class InitializeTransaction {
  static readonly type = '[Interface] Initialize Transaction';
  constructor(public interfaceObject: InterfaceObject) {}
}

export class SetConfigInfo {
  static readonly type = '[Interface] Set Config Info';
  constructor(public config: any) {}
}

export class SetPageMode {
  static readonly type = '[Interface] Set Page Mode';
  constructor() {}
}
